/**
* KPI
*/
const kPI = {
  
createKPIGroup: "/api/createKPIGroup",//创建
modifyKPIGroup: "/api/modifyKPIGroup",//修改
deleteKPIGroup: "/api/deleteKPIGroup",//删除
getKPIGroup: "/api/getKPIGroup",//查询
getKPIGroup2: "/api/getKPIGroup2",//查询
addKPI: "/api/addKPI",//添加
modifyKPI: "/api/modifyKPI",//修改
deleteKPI: "/api/deleteKPI",//删除
getKPI: "/api/getKPI",//查询
getKPI2: "/api/getKPI2",//查询
addKPIValue: "/api/addKPIValue",//添加
modifyKPIValue: "/api/modifyKPIValue",//修改
deleteKPIValue: "/api/deleteKPIValue",//删除
getKPIValue: "/api/getKPIValue",//查询
getKPIValue2: "/api/getKPIValue2",//查询
getKPIValue3: "/api/getKPIValue3",//查询
getKPIValue4: "/api/getKPIValue4",//查询
addMeasureUsingKPI: "/api/addMeasureUsingKPI",//增加
addMeasureUsingKPI2: "/api/addMeasureUsingKPI2",//增加
addMeasureUsingKPI3: "/api/addMeasureUsingKPI3",//增加
modifyMeasureUsingKPI: "/api/modifyMeasureUsingKPI",//修改
deleteMeasureUsingKPI: "/api/deleteMeasureUsingKPI",//删除
getMeasureUsingKPI: "/api/getMeasureUsingKPI",//查询
getUsingKPIByGroupId: "/api/getUsingKPIByGroupId",//根据KPI组查询
}

export default kPI